import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=b0dfa33a&scoped=true&"
import script from "./ReportPage.vue?vue&type=script&lang=ts&"
export * from "./ReportPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=b0dfa33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dfa33a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
